import { Actions, LoginLink } from 'ui-kit/actions'
import { BookCalendlyLink } from 'routes/components/Shared'
import clsx from 'clsx'
import classes from './HeaderStyles.module.scss'

export const HeaderActions = () => {
  return (
    <Actions className={classes.actions}>
      <BookCalendlyLink
        className={clsx(classes.button, classes.button__book)}
        type={'primary'}
      >
        Book a demo
      </BookCalendlyLink>

      <LoginLink
        className={clsx(classes.button, classes.button__sign)}
        type={'secondary'}
      >
        Log in / Sign up
      </LoginLink>
    </Actions>
  )
}
